var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"tencent-player",attrs:{"id":"tcPlayerId","width":"100%","preload":"auto","playsinline":"","webkit-playsinline":"","src":""}})}
var staticRenderFns = []

export { render, staticRenderFns }